import { useEffect } from "react";
import axios from "axios";
import AppContext from "../../AppContext";

let countedThisPageLoad = false;

// Records a page load without exposing statistics in either public portal.
export default function VisitCounter() {
  useEffect(() => {
    if (countedThisPageLoad) return;
    countedThisPageLoad = true;

    const incrementUrl = `${AppContext.baseApiUrl}${AppContext.urlServiceIncrementarVisitas}`;
    // Do not retry automatically: the server may have counted a request even
    // when its response is lost. Statistics failures must not break the site.
    axios.post(incrementUrl, {}).catch(() => {});
  }, []);

  return null;
}
